module.exports = __webpack_public_path__ + "img/copy-tip.529d396f.png";